var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 96,
    viewBox: "0 0 85 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 5V21H80L64 5Z",
    fill: "#484F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71H35V81H50V71Z",
    fill: "#484F79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41H35V51H50V41Z",
    fill: "#484F79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56H35V66H50V56Z",
    fill: "#484F79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56H15V66H30V56Z",
    fill: "#484F79"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41H15V51H30V41Z",
    fill: "#484F79"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71H15V81H30V71Z",
    fill: "#484F79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41H55V51H70V41Z",
    fill: "#484F79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70 71H55V81H70V71Z",
    fill: "#484F79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26V0H10H5C2.2 0 0 2.2 0 5V91C0 93.8 2.2 96 5 96H80C82.8 96 85 93.8 85 91V26H59ZM75 51V56V66V71V86H55H50H35H30H10V71V66V56V51V36H30H35H50H55H75V51Z",
    fill: "#484F79"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70 56H55V66H70V56Z",
    fill: "#484F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetIcon);
export default __webpack_public_path__ + "static/media/sheet-icon.c239c13ad348162edad842f272a9bc9f.svg";
export { ForwardRef as ReactComponent };